import Vue from "vue";

export const Device = {
  SMALL: "SMALL",
  LARGE: "LARGE",
};

let mql = matchMedia("(max-width: 800px)");

export const model = Vue.observable({
  device: mql.matches ? Device.SMALL : Device.LARGE,
});

mql.addEventListener("change", () => {
  model.device = mql.matches ? Device.SMALL : Device.LARGE;
});
